// import { useEffect, useState, useRef, useMemo } from "react";

// export const useWalkthrough = ({ steps, walkthroughKey, pageSpecific = true }) => {
//   const [run, setRun] = useState(false);
//   const [stepIndex, setStepIndex] = useState(0);
//   const isMounted = useRef(true);

//   const storageKey = useMemo(() => {
//     return pageSpecific
//       ? `${walkthroughKey}-${window.location.pathname}`
//       : walkthroughKey;
//   }, [walkthroughKey, pageSpecific]);

//   useEffect(() => {
//     isMounted.current = true;

//     const seen = localStorage.getItem(storageKey);
//     if (seen) {
//       console.log("🚫 Walkthrough already seen:", storageKey);
//       return;
//     }

//     const checkTargetsAndStart = () => {
//       const targetInfo = steps.map((step) => {
//         const el = document.querySelector(step.target);
//         return {
//           exists: !!el,
//           visible: el ? el.offsetParent !== null : false,
//         };
//       });

//       const allExist = targetInfo.every((t) => t.exists);
//       const allVisible = targetInfo.every((t) => t.visible);

//       console.log("📍 Target status:", targetInfo);
//       console.log("✅ All exist:", allExist, "👁️ All visible:", allVisible);

//       if (allExist && allVisible && steps.length > 0 && isMounted.current) {
//         console.log("🚀 Starting walkthrough");
//         setRun(true);
//         setStepIndex(0);
//       } else {
//         console.warn("❌ Cannot start walkthrough:", {
//           stepsCount: steps.length,
//           allExist,
//           allVisible,
//         });
//       }
//     };

//     const timeout = setTimeout(checkTargetsAndStart, 1000);

//     return () => {
//       isMounted.current = false;
//       clearTimeout(timeout);
//     };
//   }, [storageKey, steps]);

//   const handleJoyrideCallback = (data) => {
//     const { status, type, action } = data;

//     if (status === "finished" || status === "skipped") {
//       localStorage.setItem(storageKey, "true");
//       setRun(false);
//       setStepIndex(0);
//     } else if (type === "step:after" && action === "next") {
//       setStepIndex((prev) => prev + 1);
//     } else if (type === "step:after" && action === "prev") {
//       setStepIndex((prev) => Math.max(prev - 1, 0));
//     }
//   };

//   const joyrideProps = {
//     steps,
//     run,
//     stepIndex,
//     continuous: true,
//     scrollToFirstStep: true,
//     scrollToStep: true,
//     showProgress: true,
//     showSkipButton: true,
//     disableOverlayClose: true,
//     disableScrolling: false,
//     hideCloseButton: false,
//     callback: handleJoyrideCallback,
//     debug: true,
//     styles: {
//       options: {
//         zIndex: 10000,
//         primaryColor: "#6B46C1",
//       },
//       overlay: {
//         backgroundColor: "rgba(0, 0, 0, 0.5)",
//       },
//       spotlight: {
//         backgroundColor: "transparent",
//       },
//     },
//   };

//   const resetWalkthrough = () => {
//     localStorage.removeItem(storageKey);
//     setRun(false);
//     setStepIndex(0);

//     setTimeout(() => {
//       setRun(true);
//     }, 300);
//   };

//   const forceStart = () => {
//     setRun(true);
//     setStepIndex(0);
//   };

//   return {
//     joyrideProps,
//     resetWalkthrough,
//     forceStart,
//     isRunning: run,
//     currentStep: stepIndex,
//   };
// };

import { useCallback, useEffect, useState } from "react";
import { EVENTS, STATUS } from "react-joyride";

export const useWalkthrough = ({ steps, walkthroughKey, pageSpecific = false }) => {
  const [run, setRun] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);

  const storageKey = pageSpecific
    ? `walkthrough_shown_${walkthroughKey}`
    : "walkthrough_shown_global";

  useEffect(() => {
    const hasShown = localStorage.getItem(storageKey);
    if (!hasShown) {
      setRun(true);
    }
  }, [storageKey]);

  const handleJoyrideCallback = useCallback(
    (data) => {
      const { status, type, action } = data;

      if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
        setRun(false);
        setStepIndex(0);
        localStorage.setItem(storageKey, "true");
      }

      if (type === EVENTS.STEP_AFTER) {
        if (action === "next") {
          setStepIndex((prev) => prev + 1);
        } else if (action === "prev") {
          setStepIndex((prev) => Math.max(prev - 1, 0));
        }
      }
    },
    [storageKey],
  );

  const joyrideProps = {
    run,
    stepIndex,
    steps,
    continuous: true,
    scrollToFirstStep: true,
    showSkipButton: true,
    showProgress: true,
    disableScrolling: false,
    callback: handleJoyrideCallback,
  };

  return {
    joyrideProps,
    start: () => {
      setRun(true);
      setStepIndex(0);
    },
    stop: () => {
      setRun(false);
      localStorage.setItem(storageKey, "true");
    },
  };
};
